import { render } from "./ConsentOverlay.vue?vue&type=template&id=f327525e"
import script from "./ConsentOverlay.vue?vue&type=script&lang=js"
export * from "./ConsentOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__